export class StepProgress {
    public steps: number;
    public current: KnockoutObservable<number>;

    constructor(steps: number, current: number) {
        this.steps = steps;
        this.current = ko.observable(current);
    }
}
